<template lang="pug">
  .cookie-banner.tw-borders._fixed._z-50._bottom-0._left-0._w-full._bg-white._flex._flex-wrap._items-center._py-8._text-10.lg__text-12(v-if="show", role="dialog", aria-label="Cookie preferences")
    ._flex-1._px-6
      p We use optional cookies to understand visits and improve our shop. Choose analytics only, accept all including marketing, or reject optional cookies.
      p(v-if="error", role="status") {{ error }}
    ._flex._flex-wrap._px-6.cookie-choices
      button._h-14._px-8._border._border-gray-300(@click="choose(false, false)") Reject optional
      button._h-14._px-8._border._border-gray-300(@click="choose(true, false)") Analytics only
      button._h-14._px-8._border._border-gray-300(@click="choose(true, true)") Accept all
</template>

<script>
const { productionAllowed } = require('@/plugins/commerce-measurement')
export default {
  name: 'CookieDisclaimer',
  data () { return { choice: window.SelahatinConsent?.read(), editing: false, error: '' } },
  computed: { show () { return !this.choice || this.editing } },
  methods: {
    open () { this.editing = true },
    choose (analytics, marketing) {
      this.choice = window.SelahatinConsent.set(analytics, marketing)
      this.editing = false
      this.error = ''
      this.syncShopify(this.choice)
    },
    syncShopify (choice) {
      if (!productionAllowed(window.location, document.cookie)) return
      const sync = () => {
        if (!window.Shopify?.customerPrivacy) { this.error = 'Please confirm your cookie choice again at checkout.'; this.editing = true; window.SelahatinConsent.reloadIfNeeded(); return }
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: choice.analytics,
          marketing: choice.marketing,
          preferences: false,
          headlessStorefront: true,
          checkoutRootDomain: process.env.VUE_APP_SHOPIFY_DOMAIN,
          storefrontRootDomain: 'selahatin.com',
          storefrontAccessToken: process.env.VUE_APP_SHOPIFY_ACCESS_TOKEN
        }, () => {
          if (new URLSearchParams(window.location.search).get('analytics_test') === '1') console.info('Selahatin checkout consent saved')
          window.SelahatinConsent.reloadIfNeeded()
        })
      }
      if (window.Shopify?.customerPrivacy) return sync()
      const existing = document.querySelector('script[data-selahatin-privacy]')
      if (existing) { existing.addEventListener('load', sync, { once: true }); return }
      const script = document.createElement('script')
      script.dataset.selahatinPrivacy = 'true'
      script.src = 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js'
      script.onload = sync
      script.onerror = () => { script.remove(); window.SelahatinConsent.reloadIfNeeded(); this.error = 'Your choice is saved here. Please also check your cookie choice at checkout.'; this.editing = true }
      document.head.appendChild(script)
    }
  },
  mounted () { window.addEventListener('selahatin:consent-open', this.open) },
  beforeDestroy () { window.removeEventListener('selahatin:consent-open', this.open) }
}
</script>

<style scoped>
.cookie-choices { gap: 8px; }
.cookie-banner { gap: 12px; }
</style>
